import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { createWizardCampaignSelector } from 'containers/AwarenessCenter/constants'
import {
  CHANGE_CREATED_BY_FILTER,
  CHANGE_SORT_BY,
  CHANGE_TYPE_FILTER,
  FETCH_LANDING_PAGES_ASYNC,
} from 'containers/AwarenessCenter/WizardCampaign/steps/LandingPageStep/constants'

import { fetchLandingPagesError, fetchLandingPagesSuccess } from './actions'

const fetchLandingPagesEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      FETCH_LANDING_PAGES_ASYNC.INITIATE,
      CHANGE_CREATED_BY_FILTER,
      CHANGE_TYPE_FILTER,
      CHANGE_SORT_BY
    )
    .mergeMap(() =>
      api.wizardCampaign
        .getLandingPages(
          store.getState().partnerOptions.selectedCompany?.value,
          createWizardCampaignSelector(store.getState()).self.campaign.defaultLocaleId,
          createWizardCampaignSelector(store.getState()).self.campaign.selectedLocaleIds,
          createWizardCampaignSelector(store.getState()).landingPageStep.createdByFilter,
          createWizardCampaignSelector(store.getState()).landingPageStep.typeFilter,
          createWizardCampaignSelector(store.getState()).landingPageStep.sortByUsage
        )
        .mergeMap((response) => Observable.of(fetchLandingPagesSuccess(response)))
        .catch((error) => Observable.of(epicsErrorHandler(fetchLandingPagesError, error)))
        .takeUntil(action$.ofType(FETCH_LANDING_PAGES_ASYNC.CANCEL))
    )

export default combineEpics(fetchLandingPagesEpic)
